<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-blurbs element-with-heading" id="blurbs">
<div class="heading heading-with-title heading-without-image" id="blurbs-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise for Alex Walters</h1>
</div>
</div>
</div>
</div>
<div class="text" id="blurbs-text">
<p class="first first-in-chapter first-full-width"><b>"</b>I really enjoyed this new crime series and will definitely be looking to read the next book when it comes along." <b>Joanne Robertson - My Chestnut Reading Tree</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"Alex Walters’ crime debut is a great read, it is exciting and intriguing and I simply loved this detective novel." <b>Caroline Vincent - Bits About Books</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"Superb!" <b>Chris Nolan - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"This is the first book in a new series for Alex Walters which I am positive will gather quite a following very quickly, myself being one of them." <b>Susan Hampson - Books From Dusk Till Dawn</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"Dark, powerful and utterly absorbing with a satisfying ending I didn’t see coming. Loved it." <b>Deborah - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"A book of many threads that are skillfully drawn out and all solved by the novels end - a definite, must read." <b>Sue Gale - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"The pacing &amp; smooth prose makes for effortless reading, one of those books where you’re surprised to see how far you’ve gone when you finally look up. " <b>Sandy - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"A fantastic thriller that I would have no hesitation to recommend and will be keenly keeping an eye out for more books featuring Alec McKay!" <b>Kate Noble - The Quiet Knitter</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"This is a fast paced easy read full of twists and turns that I didn't see coming not to mention the OMG moments." <b>Shell Baker - Chelle's Book Reviews</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"I thought that this was a brilliant book and as soon as I finished I knew it was going to have to be a 5 stars read and up there with my top crime reads of the year!" <b>Donna Maguire - Donnas Book Blog</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"A great detective thriller and I look forward to McKay’s next investigation!" <b>Clair Boor - Have Books Will Read</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"This book was a nail biting ,crisp dark read...that keeps you guessing all the way through...." <b>Livia Sbarbaro - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise-for-alex-walters.vue?58f1fc05